module.exports = __webpack_public_path__ + "img/ic_stepper_large-up.c9f77a25.svg";